/* Direct CarePlix API client — calls the CarePlix staging endpoints STRAIGHT from
   the browser (no server proxy), so every request is visible in the network tab.

   The api_key + secret_key are fetched once from the server (/api/careplix/config)
   and used to sign the calls client-side. NOTE: this intentionally exposes the
   keys to the browser — it is the product decision to call the APIs directly. */

let cfgPromise = null;
function getConfig() {
  if (!cfgPromise) {
    cfgPromise = fetch("/api/careplix/config", { headers: { Accept: "application/json" } })
      .then((r) => {
        if (!r.ok) throw new Error("CarePlix config unavailable");
        return r.json();
      })
      .catch((err) => { cfgPromise = null; throw err; });
  }
  return cfgPromise;
}

async function postDirect(url, body, headers, ms, withOk) {
  const ctrl = new AbortController();
  const id = setTimeout(() => ctrl.abort(), ms);
  try {
    const r = await fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json", ...headers },
      body: JSON.stringify(body),
      signal: ctrl.signal,
    });
    if (withOk) { const data = await r.json().catch(() => ({})); return { ok: r.ok, data }; }
    return await r.json();
  } finally { clearTimeout(id); }
}

// POST /vitals/create-token — needs the secret key in the Authorization header.
export async function createToken({ employee_id, is_pulmo_required }, ms = 12000) {
  const { apiKey, secretKey, base } = await getConfig();
  return postDirect(
    `${base}/vitals/create-token`,
    { api_key: apiKey, employee_id: employee_id || "demo-user", is_pulmo_required: !!is_pulmo_required },
    { Authorization: secretKey },
    ms,
  );
}

/* NOTE: there is deliberately NO client-side add-scan. add-scan is run SERVER-SIDE
   via analyzeScan() below so the raw BP values + banding thresholds never reach the
   browser. */

/* POST /api/careplix/report — add-scan is run SERVER-SIDE so the raw vitals
   (blood pressure in mmHg) and the banding thresholds never reach the browser.
   Returns a sanitized report: { ok, verdict, wellbeing, params[] }. On a failed
   / invalid scan the server returns { ok: false } — vitals are never faked. */
export async function analyzeScan(body, ms = 45000) {
  const ctrl = new AbortController();
  const id = setTimeout(() => ctrl.abort(), ms);
  try {
    const res = await fetch("/api/careplix/report", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(body),
      signal: ctrl.signal,
    });
    const data = await res.json().catch(() => ({}));
    return { httpOk: res.ok, ...data };
  } finally { clearTimeout(id); }
}

// POST /pulmov2/v2/<label> — only needs api_key in the body. Returns { ok, data }.
export async function pulmoCall(label, body, ms = 30000) {
  const { apiKey, base } = await getConfig();
  return postDirect(`${base}/pulmov2/v2/${label}`, { ...body, api_key: apiKey }, {}, ms, true);
}
